function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/* Router Modules */
// import componentsRouter from './modules/components'
import productRouter from './modules/product';
import orderRouter from './modules/order';
import userRouter from './modules/user';
import distributionRouter from './modules/distribution';
import marketingRouter from './modules/marketing';
import financeRouter from './modules/finance';
import operationRouter from './modules/operation';
import merchant from './modules/merchant';
import pagediy from '@/router/modules/pagediy';
import areaRouter from './modules/area';
import partnerRouter from './modules/partner';
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 *
 */

export var constantRoutes = [
// 商品
productRouter,
// 订单
orderRouter,
// 会员
userRouter,
// 分销
distributionRouter,
// 营销
marketingRouter,
// 财务
financeRouter,
// 设置
operationRouter,
//商户管理
merchant,
// 页面diy
pagediy,
// 合伙人管理
partnerRouter,
// 圈层管理
areaRouter, {
  path: '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}, {
  path: '/page/design/creatDevise/:id?/:type?/:fromTo?',
  component: function component() {
    return import('@/views/pagediy/devise/creatDevise');
  },
  hidden: true
}, {
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/login',
  name: 'Login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return import('@/views/login/auth-redirect');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
},
// {
//   path: '/',
//   component: Layout,
//   redirect: '/dashboard',
//   name: 'Dashboard',
//   meta: {
//     title: '控制台',
//     icon: 'clipboard',
//   },
//   children: [
//     {
//       path: '/dashboard',
//       component: () => import('@/views/dashboard/index'),
//       name: 'DashboardIndex',
//       meta: { title: '主页', icon: 'dashboard' },
//     },
//   ],
// },
{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: '/dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'Dashboard',
    meta: {
      title: '主页',
      icon: 'dashboard',
      isAffix: true
    }
  }, {
    path: '/dashboard/statistic/product',
    component: function component() {
      return import('@/views/dashboard/product/index');
    },
    name: 'productStatistic',
    meta: {
      title: '商品统计',
      icon: 'dashboard'
    }
  }, {
    path: '/dashboard/statistic/order',
    component: function component() {
      return import('@/views/dashboard/order/index');
    },
    name: 'orderStatistic',
    meta: {
      title: '订单统计',
      icon: 'dashboard'
    }
  }, {
    path: '/dashboard/statistic/user',
    component: function component() {
      return import('@/views/dashboard/user/index');
    },
    name: 'userStatistic',
    meta: {
      title: '用户统计',
      icon: 'dashboard'
    }
  }]
}, {
  path: '/circle',
  component: Layout,
  redirect: '/circle/dashboard',
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'circle_Dashboard',
    meta: {
      title: '主页',
      icon: 'dashboard'
    }
  }]
}, {
  path: '/setting/uploadPicture',
  component: function component() {
    return import('@/components/base/uploadPicture.vue');
  },
  name: 'uploadPicture'
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

// 生成带circle前缀的路由函数
function generateCircleRoutes(routes) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'circle';
  var split = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isChild = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return routes.map(function (route) {
    // 跳过已有的 /circle 路由
    // if (route.path === '/circle') return route;
    var newRoute;
    if (isChild) {
      newRoute = _objectSpread(_objectSpread({}, route), {}, {
        name: route.name ? "circle_".concat(route.name) : undefined,
        meta: _objectSpread(_objectSpread({}, route.meta), {}, {
          isCircleRoute: true
        })
      });
    } else {
      if (route.path != '*') {
        newRoute = _objectSpread(_objectSpread({}, route), {}, {
          path: route.path == '/' ? route.path + prefix : split + prefix + route.path,
          name: route.name ? "circle_".concat(route.name) : undefined,
          meta: _objectSpread(_objectSpread({}, route.meta), {}, {
            isCircleRoute: true
          })
        });
      } else {
        newRoute = _objectSpread(_objectSpread({}, route), {}, {
          meta: _objectSpread(_objectSpread({}, route.meta), {}, {
            isCircleRoute: true
          })
        });
      }
    }

    // 递归处理子路由
    if (route.children) {
      newRoute.children = generateCircleRoutes(route.children, 'circle', '', true); // 子路由不需要再加前缀
    }
    // if(route.redirect == '/dashboard'){
    //   newRoute.redirect = '/circle/dashboard';
    // }
    return newRoute;
  });
}

// 动态添加circle路由
var circleRoutes = generateCircleRoutes(constantRoutes, 'circle', '/');

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
router.addRoutes(circleRoutes);
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;